import React, { Component } from 'react';
import "./Banner.scss";

export default class Banner extends Component {
   
   redirect=(url)=>{ 
       
    
    window.open(url,'_parent');}
      
   
    render() {
        return (
         
            // <div className="main-container" onClick={()=>{
            //     this.redirect('https://www.toyota.es/service-and-accessories/warranty-and-assistance/toyota-life#video')}}>
            //     <img className="banner-img" src="./images/Fondo@2x_Dektop.jpg" ></img>
            //     <img className="banner-img-mobile" src="./images/Fondo@2x_Mobile.jpg" ></img>
            //     <div className="banner-container" >
            //         <div className="column-1-banner">
            //             <div className="text-banner">
            //                 <p className="title-text-banner">TOYOTA RELAX</p>
            //                 <p className="body-text-banner">HASTA 10 AÑOS DE GARANTÍA AL REALIZAR
            //                     TU MANTENIMIENTO CON TOYOTA</p>
            //                 <button className="button-mas-informacion">MÁS INFORMACIÓN</button>
            //             </div>
                        
            //         </div>
            //     </div>
            // </div>

            <div className="main-container">
              {/* // this.redirect('https://www.toyota.es/service-and-accessories/warranty-and-assistance/toyota-life#video')}}>
              // <img className="banner-img" src="./images/Fondo@2x_Dektop.jpg" ></img>
              // <img className="banner-img-mobile" src="./images/Fondo@2x_Mobile.jpg" ></img>
              // <div className="banner-container" >
              //     <div className="column-1-banner">
              //         <div className="text-banner">
              //             <p className="title-text-banner">TOYOTA RELAX</p>
              //             <p className="body-text-banner">HASTA 10 AÑOS DE GARANTÍA AL REALIZAR
              //                 TU MANTENIMIENTO CON TOYOTA</p>
              //             <button className="button-mas-informacion">MÁS INFORMACIÓN</button>
              //         </div>
                      
              //     </div>
              // </div> */}
            </div>
    )
  }
}
